export enum InspectionCategories {
    Property = 1,
    Dumpster = 2,
    FireSystems = 3,
    Landscaping = 4,
    Lighting = 5,
    ParkingLot = 6,
    Sidewalk = 7,
    Signage = 8,
    VacantUnits = 9,
    Roof = 10,
    Building = 11,
}

export const InspectionCategoriesDisplayName = {
    [InspectionCategories.Property]: 'Property',
    [InspectionCategories.Dumpster]: 'Dumpster',
    [InspectionCategories.FireSystems]: 'Fire Systems',
    [InspectionCategories.Landscaping]: 'Landscaping',
    [InspectionCategories.Lighting]: 'Lighting',
    [InspectionCategories.ParkingLot]: 'Parking Lot',
    [InspectionCategories.Sidewalk]: 'Sidewalk',
    [InspectionCategories.Signage]: 'Signage',
    [InspectionCategories.VacantUnits]: 'Vacant Units',
    [InspectionCategories.Roof]: 'Roof',
    [InspectionCategories.Building]: 'Building',
};
